import { ChecklistElementStyles } from "./documentStyles";

export const checklistRoles = [
  "flightPlanning",
  "beforeSimStart",
  "beforeSimFlightStart",
  "cockpitPreparation",
  "beforeFlightStart",
  "beforePushback",
  "beforeEngineStart",
  "engineStart",
  "afterEngineStart",
  "beforeTaxi",
  "taxi",
  "beforeTakeoff",
  "takeoff",
  "climbOut",
  "cruise",
  "beforeDescent",
  "descent",
  "approach",
  "landing",
  "goAround",
  "afterLanding",
  "parking",
  "shutdown",
  "securing",
  "afterSimShutdown",
] as const;
export type ChecklistRole = typeof checklistRoles[number];
export const checklistRoleDefaultTitles: Record<ChecklistRole, string> = {
  flightPlanning: "Flight Planning",
  beforeSimStart: "Before Simulator Start",
  beforeSimFlightStart: "Before Loading Simulator Flight",
  cockpitPreparation: "Cockpit Preparation",
  beforeFlightStart: "Before Start",
  beforePushback: "Before Pushback",
  beforeEngineStart: "Before Engine Start",
  engineStart: "Engine Start",
  afterEngineStart: "After Engine Start",
  beforeTaxi: "Before Taxi",
  taxi: "Taxi",
  beforeTakeoff: "Before Takeoff",
  takeoff: "Takeoff",
  climbOut: "Climb",
  cruise: "Cruise",
  beforeDescent: "Before Descent",
  descent: "Descent",
  approach: "Approach",
  landing: "Landing",
  goAround: "Go Around",
  afterLanding: "After Landing",
  parking: "Parking",
  shutdown: "Shutdown",
  securing: "Securing the Aircraft",
  afterSimShutdown: "After Simulator Shutdown",
} as const;

export interface Identified {
  id: string;
}

export interface EditableString extends Identified {
  content: string;
  editing: "internal" | "external" | false;
}

export type ChecklistDocumentElement = Checklist | PageBreak;

export interface ChecklistContents {
  title: EditableString;
  checklists: Array<ChecklistDocumentElement>;
}

export interface Checklist extends Identified {
  type: "checklist";
  title: EditableString;
  content: Array<ChecklistElement>;
  role?: ChecklistRole[];
}

export type ChecklistElement = ChecklistItem | ChecklistHeader;

export interface ChecklistItem extends Identified {
  type: "item";
  item: EditableString;
  setting: EditableString;
  styles?: ChecklistElementStyles;
}

export interface ChecklistHeader extends Identified {
  type: "header";
  text: EditableString;
  styles?: ChecklistElementStyles;
}

export function isChecklistItem(element: ChecklistElement): element is ChecklistItem {
  return (
    element.type === "item" &&
    (element as ChecklistItem).item !== undefined &&
    (element as ChecklistItem).setting !== undefined
  );
}

export function isChecklistHeader(element: ChecklistElement): element is ChecklistHeader {
  return element.type === "header" && (element as ChecklistHeader).text !== undefined;
}

export const pageBreak = "page-break";
export interface PageBreak extends Identified {
  type: typeof pageBreak;
}

export function isPageBreak(element: ChecklistDocumentElement): element is PageBreak {
  return (element as PageBreak).type === pageBreak;
}
export function isChecklist(element: ChecklistDocumentElement): element is Checklist {
  return (element as Checklist).type === "checklist";
}
